import React from 'react';
import { Dropdown } from '../common/Form';
import PageHeader from '../PageHeader';
import useResponsive from '../../hooks/useResponsive';

interface MediaLibraryTopBarProps {
  mediaTypeFilter: 'all' | 'image' | 'video';
  // eslint-disable-next-line no-unused-vars
  onTypeChange: (type: 'all' | 'image' | 'video') => void;
}

const MediaLibraryTopBar = ({ mediaTypeFilter, onTypeChange }: MediaLibraryTopBarProps) => {
  const { isDesktop } = useResponsive();

  const filterValues = isDesktop
    ? [
        { value: 'all', label: 'All Media' },
        { value: 'image', label: 'Images' },
        { value: 'video', label: 'Video' }
      ]
    : [
        { value: 'all', label: 'All' },
        { value: 'image', label: 'Images' },
        { value: 'video', label: 'Video' }
      ];

  return (
    <PageHeader title="MEDIA">
      <Dropdown
        className="media-library-top-bar__filter"
        onChange={onTypeChange}
        value={mediaTypeFilter}
        values={filterValues.map((item) => ({ label: item.label, value: item.value }))}
      />
    </PageHeader>
  );
};

export default MediaLibraryTopBar;
